import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import { Col, Row } from 'react-bootstrap';
import { localizedStrings } from "../../../../../localization/index"
import Truncate from 'src/components/truncate';

class SearchListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <div className={cx(styles.item, entityStyles.search, this.props.className)}>
        <div className={cx(styles.icon, entityStyles.icon)}>{this.props.index + 1}</div>
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>{_.get(this.props.item, 'query')}</Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'totalCount')} {this.localizedTabsCommons.searches}</li>
          </ul>
        </div>
      </div>
    );
  }
}

class SearchGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const query = _.get(this.props.item, 'query');

    return (
      <Col key={query} md={6} className={cx(styles.row, entityStyles.search, entityStyles.grid)}> 
        <Col className={styles.column} md={8}>
          <div className={cx(styles.item, this.props.className)}>
          <div className={cx(styles.icon, entityStyles.icon)}>{this.props.index + 1}</div>
            <div className={styles.mostSearchQueryTitle} >
              <h5 className={styles.title}>{query}</h5>
            </div>
          </div>
        </Col>
        <Col className={styles.column} md={4}>{_.get(this.props.item, 'totalCount')}</Col>
      </Col>
    );
  }
}

class SearchTagListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const tag = _.get(this.props.item, 'key');
    return (
      <a href={`/search/assets?tags=${tag}`} target='_blank' className={cx(styles.item, entityStyles.search, this.props.className)}>
        <div className={cx(styles.icon, entityStyles.icon)}>{this.props.index + 1}</div>
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>{tag}</Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'assetCount')} {this.localizedTabsCommons.assets}</li>
            <li>{_.get(this.props.item, 'searchCount')} {this.localizedTabsCommons.searches}</li>
          </ul>
        </div>
      </a>
    );
  }
}

class SearchTagGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const tag = _.get(this.props.item, 'key');
    return (
      <Col md={8} className={cx(styles.row, entityStyles.search, entityStyles.grid)}>
        <Col className={styles.column} md={8}>
          <a href={`/search/assets?tags=${tag}`} target='_blank'  className={cx(styles.item, this.props.className)}>
            <div className={cx(styles.icon, entityStyles.icon)}>{this.props.index + 1}</div>
            <div>
              <h5 className={styles.title}>{tag}</h5>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'assetCount')}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'searchCount')}</Col>
      </Col>
    );
  }
}

const Search = {
  List: SearchListItem,
  Grid: SearchGridItem,
  Tag: {
    List: SearchTagListItem,
    Grid: SearchTagGridItem
  }
};

export default Search;